import React, { Component } from 'react';
import { View, FlatList, Dimensions } from '../src/web/react-native';
import moment from 'moment';
import { connect } from 'react-redux';
import ShiftLogs from './MyPosts/ShiftLogs';
export class InProgress extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentShiftStart: '',
      width: Dimensions.get('window').width,
    };
  }

  async componentDidMount() {
    Dimensions.addEventListener('change', () => {
      this.setState({
        width: Dimensions.get('window').width,
        height: Dimensions.get('window').height,
      });
    });
    this.focusInProgressListener = this.props.navigation.addListener('focus', async () => {
      this.setState({
        // inProgressCount: this.props.shiftLogs.filter(val => val.status != 'TakenOver').length
      });
    });
  }
  componentWillUnmount() {
    this.focusInProgressListener();
  }

  render() {
    return (
      <View style={{ flex: 1, width: this.state.width, backgroundColor: '#fff' }}>
        <FlatList
          data={
            this.props.route.params && this.props.route.params.isTeamLog
              ? this.props.teamShiftLogs.filter((val) => val.status !== 'TakenOver')
              : this.props.shiftLogs.filter((val) => val.status !== 'TakenOver')
          }
          extraData={this.props}
          renderItem={({ item }) => {
            return (
              <Item
                item={item}
                navigation={this.props.navigation}
                isTeamLog={this.props.route.params && this.props.route.params.isTeamLog}
                currentShiftStart={this.props.currentShiftStart}
                currentShiftEnd={this.props.currentShiftEnd}
                previousShiftStart={this.props.previousShiftStart}
                previousShiftEnd={this.props.previousShiftEnd}
              />
            );
          }}
          keyExtractor={(item) => item.shiftSummaryID.toString()}
        />
      </View>
    );
  }
}
function Item({
  item,
  navigation,
  currentShiftStart,
  currentShiftEnd,
  previousShiftStart,
  previousShiftEnd,
  isTeamLog,
}) {
  let width = Dimensions.get('window').width;
  // 2020-07-29T23:30:00.0000000Z
  let isPrev =
    moment(item.shiftStart).isSameOrAfter(previousShiftStart) &&
    moment(item.shiftEnd).isSameOrBefore(previousShiftEnd);
  let isCurrent =
    moment(item.shiftStart).isSameOrAfter(currentShiftStart) &&
    moment(item.shiftEnd).isSameOrBefore(currentShiftEnd);
  let displayDate = '';
  let description = '';
  let user = '';
  if (item.status === 'Submitted' || item.status === 'PreSubmission') {
    description = 'Submitted';
    user = item.submitUser;
    displayDate = moment(item.submitTime).format('MMM DD, YYYY h:mm a');
  } else if (item.status === 'TakenOver') {
    description = 'Taken Over';
    user = item.takeoverUser;
    displayDate = moment(item.takeoverTime).format('MMM DD, YYYY h:mm a');
  } else {
    description = 'Created';
    user = item.createUser;
    displayDate = moment(item.createTime).format('MMM DD, YYYY h:mm a');
  }

  return (
    <ShiftLogs
      item={item}
      isPrev={isPrev}
      isCurrent={isCurrent}
      description={description}
      user={user}
      displayDate={displayDate}
      width={width}
      navigation={navigation}
      isTeamLog={isTeamLog}
    />
  );
}

const mapStateToProps = (state) => ({
  shiftLogs: state.shiftLogs.shiftLogs,
  teamShiftLogs: state.shiftLogs.teamShiftLogs,
  currentShiftStart: state.preference.currentShiftStart,
  currentShiftEnd: state.preference.currentShiftEnd,
  previousShiftStart: state.preference.previousShiftStart,
  previousShiftEnd: state.preference.previousShiftEnd,
});

export default connect(mapStateToProps)(InProgress);
